import { Icon, type StackProps, Text, VStack } from "@chakra-ui/react";
import type { FC, ReactNode } from "react";
import { LuBox } from "react-icons/lu";

interface LoopFallBackStateProps {
    containerProps?: StackProps;
    icon?: ReactNode;
    message?: string;
}
const LoopFallBackState: FC<LoopFallBackStateProps> = ({
    containerProps,
    icon,
    message = "No Orders to show",
}) => (
    <VStack
        textAlign="center"
        fontWeight="medium"
        {...containerProps}
        color="gray.400"
    >
        <Icon>{icon ? icon : <LuBox />}</Icon>
        <Text>{message}</Text>
    </VStack>
);

export default LoopFallBackState;
